<template>
    <div class="recorretd-panel">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pickerConfig="config.pickerConfig"
            :initSearchInfo="searchParams"
            @searchChange="searchChange"
            searchId="siteCorrection"
            pageID="siteCorrection"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        ></m-pane>
    </div>
</template>
<script>
import mPane from '@/components/lots/VirtualPanel/index.vue';
import config from './QueryRecordConfig';
import dayjs from 'dayjs';
import { Message } from 'element-ui';
import { getGisHistory } from '../api';
export default {
    components: {
        mPane
    },
    data() {
        return {
            config,
            totalData: [],

            loading: false,
            // 初始化数据，尝试修复非常小概率发生的数据无法改变问题
            searchParams: {
                address: '',
                // 最近30天
                searchBeginTime: [
                    dayjs().subtract(30, 'day').format('YYYY-MM-DD HH:mm:ss'),
                    dayjs().format('YYYY-MM-DD HH:mm:ss')
                ]
            },
            lastParams: {},
            pageSize: 10,
            pageNo: 1,
            pageTotal: 10
        };
    },
    methods: {
        pageChange(data) {
            this.pageNo = data;
            // 分页器页数变化
            this.searchChange();
        },
        sizeChange(data) {
            this.pageNo = 1;
            this.pageSize = data;
            // 分页器页数大小变化
            this.searchChange();
        },
        searchChange(data = this.lastParams) {
            // 用户未录入地址，提示报错：请输入地址后再进行查询！！
            if (!data.address && (!data.searchBeginTime || !data.searchBeginTime.length)) {
                return Message.warning('请输入地址或者查询时间！');
            }
            const [startTime, endTime] = data.searchBeginTime || [];
            /**
             * 用户未录入地址，时间超过90天，不允许查询，提示：未输入地址，纠错记录查询范围不允许超过90天！！
             * 用户选择时间超过180天，提示报错：纠错记录查询范围不允许超过180天，请重新选择时间范围！！
             */
            if (!data.address) {
                if (dayjs(endTime).diff(dayjs(startTime), 'day') > 90) return Message.warning('未输入地址，纠错记录查询范围不允许超过90天！！');
            } else {
                const diff = dayjs(endTime).diff(dayjs(startTime), 'day');
                if (diff > 180) return Message.warning('纠错记录查询范围不允许超过180天，请重新选择时间范围！！');
            }
            const searchParams = {
                ...data,
                startTime,
                endTime,
                pageSize: this.pageSize,
                pageNo: this.pageNo
            };
            this.lastParams = data;
            this.loading = true;
            return getGisHistory(searchParams).then((res) => {
                this.totalData = res.data.list;
                this.pageTotal = res.data.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
<style lang="less">
.recorretd-panel {
    .el-table {
        height: 60vh !important;
    }
}
</style>
